import { Box } from "@mui/material";
import Header from "../../../components/Header";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import {
  addIngrediant,
  getIngrediantsStatus,
  getIngrediantsError,
  getIngrediantsSuccess,
  getIngrediantsLoading,
  updateStatus,
} from "../../../features/ingrediantSlice";
import { useNavigate } from "react-router-dom";
import { useRestaurant } from "../../../hooks/RestaurantContext";
import IngredientForm from "./ingrediantForm";
import { getImageFormFields } from "../../../global/functions/imageHelper";
import BackButton from "../../../components/backButton";
import { useTranslation } from "react-i18next";

const AddIngrediant = ({ onClose, isDialog = false }) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { restaurantId } = useRestaurant();
  const [previewImage, setPreviewImage] = useState(null);
  const status = useSelector(getIngrediantsStatus);
  const error = useSelector(getIngrediantsError);
  const loading = useSelector(getIngrediantsLoading);
  const success = useSelector(getIngrediantsSuccess);

  const initialValues = {
    name: "",
    image: "",
    price: 0,
    suppPrice: 0,
    variations: [],
    outOfStock: false,
    visible: true,
  };

  const handleFormSubmit = (values) => {
    const imageFields = getImageFormFields(previewImage);
    if (!imageFields.image && !imageFields.mediaId) {
      toast.error("Veuillez sélectionner ou télécharger une image");
      return;
    }
    const formData = {
      name: values.name,
      price: values.price,
      suppPrice: values.suppPrice,
      outOfStock: values.outOfStock,
      visible: values.visible,
      ...imageFields,
      variations: values.variations,
    };
    dispatch(addIngrediant({ body: formData, restaurantId }))
      .unwrap()
      .then((createdIngrediant) => {
        toast.success("Ingrédient créé");
        if (isDialog) {
          onClose?.(createdIngrediant); 
        } else {
          navigate("/ingrediants");
        }
      })
      .catch((err) => {
        toast.error(err?.message || "Erreur");
      });
  };

 useEffect(() => {
  if (status === "addSuccess") {
    toast.success(success);
    if (!isDialog) {
      navigate("/ingredients");
    }
  } else if (status === "addError") {
    toast.error(error);
  }
  dispatch(updateStatus());
}, [status, error, dispatch, navigate, isDialog, success]);

  return (
    <Box m="20px" className="main-application">
      <BackButton />
      <Header
        title={t("headers.addIngredient")}
        subtitle={t("headers.addIngredientSub")}
      />
      <IngredientForm
        buttonText={t("common.submit")}
        handleFormSubmit={handleFormSubmit}
        initialValues={initialValues}
        previewImage={previewImage}
        setPreviewImage={setPreviewImage}
        loading={loading}
        isDialog={isDialog}
      />
    </Box>
  );
};

export default AddIngrediant;
